<template>
      <div class="sidebar" data-color="white" data-active-color="danger">
      <div class="logo">
        <a href="" class="simple-text ">
           <div class="">
            <img src="/assets/img/ostimlogo.png" class="sidelogo">
          </div> 
        </a>
        
      </div>
      <div class="sidebar-wrapper">
        <ul class="nav">
          <router-link
          active-class="active"
          exact
          tag="li"
          class=""
          to="/home"
          >
            <a href="javascript:;">
              <i class="nc-icon nc-bank"></i>
              <p>ANA SAYFA</p>
            </a>         
          </router-link>
          <router-link v-show="false"
           active-class="active"           
           tag="li"
           class=""
           to="/student"
            >
            <a href="javascript:;">
              <i class="nc-icon nc-hat-3"></i>
              <p>ÖĞRENCİLER</p>
            </a>
          </router-link>
          <router-link
           active-class="active"
           tag="li"
           class=""
           to="/company"
          >
            <a href="javascript:;">
              <i class="nc-icon nc-badge"></i>
              <p>FİRMALAR</p>
            </a>
          </router-link>
          <router-link
           active-class="active"
           tag="li"
           class=""
           to="/process"
          >
            <a href="javascript:;">
              <i class="nc-icon nc-single-copy-04"></i>
              <p>SÜREÇ TAKİP</p>
            </a>
          </router-link>
          <router-link
           active-class="active"
           tag="li"
           class=""
           to="/log" v-show="false"
          >
            <a href="javascript:;">
              <i class="nc-icon nc-atom"></i>
              <p>LOG</p>
            </a>
          </router-link>
        </ul>
      </div>
    </div>

</template>

<script>
export default {
    
}
</script>

<style>
  .sidelogo{
    width: 200px;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/Sidebar.vue